let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggwJy")).then(() => parcelRequire('65VUA'));